<template>
    <div class="accordion" :class="{ 'is-active': active }">
        <dt
            @click="toggle"
            class="d-flex flex-row justify-content-between align-items-center accordion-trigger"
        >
            <div class="d-flex">
                <slot name="title" />
            </div>
            <div class="d-flex flex-shrink-1 accordion-trigger-icon">
                <slot name="icon">
                    <i class="fas fa-caret-down"></i>
                </slot>
            </div>
        </dt>
        <transition
            name="accordion"
            @enter="startTransition"
            @after-enter="endTransition"
            @before-leave="startTransition"
            @after-leave="endTransition"
        >
            <dd v-if="active" class="accordion-body mb-0">
                <slot name="content" />
            </dd>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            active: this.value
        };
    },
    methods: {
        toggle() {
            this.active = !this.active;
        },

        startTransition(el) {
            el.style.height = el.scrollHeight + "px";
        },

        endTransition(el) {
            el.style.height = "";
        }
    },
    watch: {
        value(val) {
            this.active = val;
        },
        active(val) {
            this.$emit("input", val);
        }
    }
};
</script>

<style lang="scss" scoped>
$transition-function: 0.25s ease;

.accordion {
    width: 100%;

    .accordion-trigger {
        width: 100%;
        cursor: pointer;
    }

    .accordion-body {
        overflow: hidden;
    }

    .accordion-trigger-icon {
        height: 100%;
        transform: rotate(0deg);
        transition: transform $transition-function;
    }
}

.accordion-trigger-icon {
    .is-active & {
        transform: rotate(180deg);
    }
}

.accordion {
    &-enter-active,
    &-leave-active {
        will-change: height;
        transition: height $transition-function;
    }

    &-enter,
    &-leave-to {
        height: 0 !important;
    }
}
</style>
